import Big from "big.js";

export const calculateSubscriptionTotal = (plan, processedAddonPacks) => {
    console.log('aaa calculateSubscriptionTotal', {plan, processedAddonPacks});
    const planPriceB = plan ? Big(plan?.unit_price || 0) : Big(0);
    const addonsPriceB = processedAddonPacks.reduce(
        (acc, addon) => acc.plus(Big(addon?.totalPrice || 0)), Big(0));
    const totalB = planPriceB.plus(addonsPriceB);

    return {
        planPrice: planPriceB ? planPriceB.toFixed(2) : 0,
        addonsPrice: addonsPriceB ? addonsPriceB.toFixed(2) : 0,
        subtotal: totalB ? totalB.toFixed(2) : 0,
    };
};
